/**

 * Vervit — Cart drawer / cart page → Razorpay Magic Checkout.

 */

(function () {

  const CART_PAGE_CHECKOUT_ID = 'CartPage-Checkout';

  const CART_DRAWER_CHECKOUT_ID = 'CartDrawer-Checkout';

  const MAIN_CART_CHECKOUT_ID = 'checkout';

  const CHECKOUT_BTN_SELECTOR = '.vrv-cart-page__checkout-btn, [data-vrv-magic-checkout]';

  const MAGIC_READY = 'vrv:magic-checkout-ready';

  const MAX_WAIT_MS = 8000;

  const POLL_MS = 100;



  function isMagicReady() {

    return typeof window.openRzpCheckout === 'function';

  }



  function waitForMagic() {

    if (isMagicReady()) return Promise.resolve();



    return new Promise((resolve, reject) => {

      const timeout = setTimeout(() => {

        clearInterval(poll);

        reject(new Error('Razorpay Magic Checkout did not load'));

      }, MAX_WAIT_MS);



      const done = () => {

        clearTimeout(timeout);

        clearInterval(poll);

        resolve();

      };



      document.addEventListener(MAGIC_READY, done, { once: true });



      const poll = setInterval(() => {

        if (isMagicReady()) done();

      }, POLL_MS);

    });

  }



  function watchMagicScriptLoad() {

    const script = document.querySelector('script[src*="magic-shopify.js"]');

    if (!script) return;

    if (script.dataset.vrvMagicLoadBound) return;

    script.dataset.vrvMagicLoadBound = 'true';

    script.addEventListener('load', () => {

      if (

        window.vrvGiftWrapHelpers &&

        typeof window.vrvGiftWrapHelpers.reinstallAfterOuterFetchWrap === 'function'

      ) {

        window.vrvGiftWrapHelpers.reinstallAfterOuterFetchWrap();

      }

      document.dispatchEvent(new CustomEvent(MAGIC_READY));

      if (typeof window.vrvInstallOpenRzpCheckoutGuard === 'function') {

        window.vrvInstallOpenRzpCheckoutGuard();

      }

    });

    if (isMagicReady()) {

      document.dispatchEvent(new CustomEvent(MAGIC_READY));

    }

  }



  async function openMagicCheckout(clickEvent) {

    console.log('[CHECKOUT DEBUG] openMagicCheckout(): resolving which checkout path to use.', {
      hasLaunchRazorpayCartCheckout: typeof window.vrvLaunchRazorpayCartCheckout === 'function',
      hasProceedToCheckoutPreview: typeof window.vrvProceedToCheckoutPreview === 'function',
      hasOpenRzpCheckout: typeof window.openRzpCheckout === 'function',
    });

    try {

      if (typeof window.vrvClearStaleBuyNowForDrawerCheckout === 'function') {

        window.vrvClearStaleBuyNowForDrawerCheckout();

      }



      if (typeof window.vrvLaunchRazorpayCartCheckout === 'function') {

        console.log('[CHECKOUT DEBUG] openMagicCheckout(): using vrvLaunchRazorpayCartCheckout (primary path).');
        const result = await window.vrvLaunchRazorpayCartCheckout(clickEvent);
        console.log('[CHECKOUT DEBUG] openMagicCheckout(): vrvLaunchRazorpayCartCheckout resolved with', result);
        return result;

      }



      await waitForMagic();



      if (typeof window.vrvProceedToCheckoutPreview === 'function') {

        console.log('[CHECKOUT DEBUG] openMagicCheckout(): using vrvProceedToCheckoutPreview (fallback path).');
        const opened = await window.vrvProceedToCheckoutPreview(clickEvent);

        return Boolean(opened);

      }



      if (typeof window.openRzpCheckout === 'function') {

        console.log('[CHECKOUT DEBUG] openMagicCheckout(): using raw window.openRzpCheckout (last-resort fallback path).');
        window.openRzpCheckout(clickEvent || null, { pageType: 'cart' });

        return true;

      }



      console.error('[CHECKOUT DEBUG] openMagicCheckout(): no checkout path available at all (vrvLaunchRazorpayCartCheckout, vrvProceedToCheckoutPreview, and openRzpCheckout are all missing).');
      return false;

    } catch (err) {
      console.error('[CHECKOUT DEBUG] openMagicCheckout(): checkout failed. Fallback to standard checkout.', err);
      window.location.href = '/checkout';
      return true;
    }

  }



  async function handleCheckoutClick(event) {

    console.log('[CHECKOUT DEBUG] Step 0: Checkout button/form click handler triggered.', {
      target: event && event.currentTarget && (event.currentTarget.id || event.currentTarget.tagName),
    });

    event.preventDefault();

    event.stopImmediatePropagation();



    const btn =

      event.currentTarget && event.currentTarget.tagName === 'FORM'

        ? event.submitter ||

          event.currentTarget.querySelector('[data-vrv-magic-checkout], #checkout, button[name="checkout"]')

        : event.currentTarget;



    if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') {
      console.warn('[CHECKOUT DEBUG] Step 0: click ignored -- button missing or already disabled/busy.', { btn: btn && btn.id });
      return;
    }



    btn.setAttribute('aria-busy', 'true');

    if ('disabled' in btn) btn.disabled = true;

    console.log('[CHECKOUT DEBUG] Step 0: button disabled, starting checkout flow.');



    const opened = await openMagicCheckout(event);



    btn.removeAttribute('aria-busy');

    if ('disabled' in btn) btn.disabled = false;



    if (!opened) {

      console.error('[CHECKOUT DEBUG] Checkout flow finished but did NOT open Razorpay/Magic Checkout. This is the stopping point -- see the [CHECKOUT DEBUG] logs above for the exact step and reason.');

    } else {

      console.log('[CHECKOUT DEBUG] Checkout flow finished successfully -- Razorpay/Magic Checkout should be open now.');

    }

  }



  function bindButton(btn) {

    if (!btn || btn.dataset.vrvMagicBound) return;

    btn.dataset.vrvMagicBound = 'true';

    btn.addEventListener('click', handleCheckoutClick, true);

  }



  function bindAll() {

    bindButton(document.getElementById(CART_PAGE_CHECKOUT_ID));

    bindButton(document.getElementById(CART_DRAWER_CHECKOUT_ID));

    bindButton(document.getElementById(MAIN_CART_CHECKOUT_ID));

    document.querySelectorAll(CHECKOUT_BTN_SELECTOR).forEach(bindButton);

    document.querySelectorAll('button[name="checkout"], button[data-vrv-magic-checkout]').forEach(bindButton);

  }



  function onCheckoutFormSubmit(event) {

    const form = event.target;

    if (!form || form.tagName !== 'FORM') return;



    const submitter =

      event.submitter ||

      (document.activeElement && document.activeElement.form === form ? document.activeElement : null);



    const isCheckoutSubmit =

      (submitter && (submitter.name === 'checkout' || submitter.id === 'checkout')) ||

      (submitter && submitter.getAttribute('data-vrv-magic-checkout') != null);



    if (!isCheckoutSubmit) return;



    const isCartForm =

      form.id === 'cart' ||

      form.id === 'CartDrawer-Form' ||

      form.id === 'cart-notification-form' ||

      form.getAttribute('action') === ((window.routes && window.routes.cart_url) || '/cart');



    if (!isCartForm) return;



    handleCheckoutClick(event);

  }



  document.addEventListener('DOMContentLoaded', () => {

    watchMagicScriptLoad();

    bindAll();

    document.addEventListener('submit', onCheckoutFormSubmit, true);

  });



  document.addEventListener('cart:updated', bindAll);



  watchMagicScriptLoad();

  if (document.readyState !== 'loading') bindAll();

})();


